import _ from 'lodash';
import LogRocket from 'shared/logrocket';
import validateSubmit from 'shared/checkout/actions/validate-submit';
import validateCart from 'shared/checkout/actions/validate-cart';
import buildOrder from 'shared/checkout/actions/build-order';
import { persistCartData } from 'shared/actions/cart';

// called via shared/checkout/components/confirmation/submit 48
// called via src/modals/kiosk-checkout/modal.jsx 90
export default async function onClickSubmit(
  submitOrder,
  { Cart, UI, User, apolloClient, showErnie, Checkout, useOrderTypesConfigV2 = false, checkOnDuty = false }
) {
  const { isVariant, addErrors } = Checkout;
  // attempt to auto save specific sections
  try {
    await Cart.medicalComponentRef?.current?.onSave();
    if (Cart.order.paymentMethod === 'payOnlineMerrco') {
      await Cart.paysafeFormRef?.current?.handleSave();
    }
    await Cart.orderTypeComponentRef?.current?.onSave();
    await Cart.scheduledOrderingRef?.current?.handleSave();
    // if we don't have a checkout token, persist cart to get one
    if (!Cart.checkoutToken) {
      await persistCartData(apolloClient, Cart, UI, User);
    }
  } catch (e) {
    // log error to console--ernie logging is handled in respective onSave() calls above
    console.error(e);
    return { error: true, msg: e };
  }

  // validate the cart
  const { proceed: cartIsValid, outOfStockItem, returnToMenu } = await validateCart({
    Cart,
    UI,
    apolloClient,
    showErnie,
    isVariant,
    useOrderTypesConfigV2,
    checkOnDuty,
  });
  if (!cartIsValid) {
    return { error: true, outOfStockItem, returnToMenu };
  }

  // validate the order
  const { proceed: orderIsValid } = await validateSubmit({
    Cart,
    UI,
    User,
    showErnie,
    Checkout,
    useOrderTypesConfigV2,
  });
  if (!orderIsValid) {
    return { error: true };
  }
  // build the order
  const { order } = buildOrder({ Cart, UI, User, Checkout });

  // server side validations & attempt to submit the order
  const response = await submitOrder({ variables: { input: order } });
  const valid = _.get(response, 'data.createOrderV2.valid', false);
  const serverErrors = _.get(response, 'data.createOrderV2.errors', false);
  if (!valid && !_.isEmpty(serverErrors)) {
    addErrors(serverErrors);
  } else if (!valid) {
    // we don't have validation errors here but something broke. Alert the user and notify high alert rollbar
    console.error('CheckoutError', response);
    UI.showErnie('Error submitting order. Please contact customer support.');
    LogRocket?.track('CheckoutError');
  }
  return response;
}
